export default __webpack_public_path__ + "static/media/822.346d270a.png";